
























































































































import Vue, { VueConstructor } from "vue";
import ChoseLicense from "@/components/organisms/wizard/ChoseLicense.vue";
import NewLicense from "@/components/organisms/wizard/NewLicense.vue";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import { LicenseDetail, LicenseProduct } from "@/models/license";
import WizardService from "@/services/wizardService";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "StepLicense",
  mixins: [wizardStepsMixin],
  data() {
    return {
      licenseMode: undefined as string | undefined,
      license: undefined as LicenseDetail | undefined,
      avaliableTrials: [] as LicenseProduct[],
      canActivateTrial: process.env.VUE_APP_CAN_ACTIVATE_TRIAL === "true",
    };
  },
  components: { NewLicense, ChoseLicense },
  methods: {
    syncLicense(lic: LicenseDetail) {
      this.license = lic;
      this.$emit("onChoseLicense", lic);
    },
    associateLicense(lic: LicenseDetail) {
      this.syncLicense(lic);
      this.activateSeat();
    },
    async activateSeat() {
      if (this.license) {
        try {
          this.loading = true;
          await WizardService.reserveSeat(
            this.deviceConfiguration.deviceConfigurationId,
            this.license.licensePackageId,
            this.deviceConfiguration.deviceType
          );
          this.onNext();
        } catch (e) {
          this.handleError(e);
        } finally {
          this.loading = false;
        }
      }
    },

    async checkAvailableTrials() {
      try {
        this.loading = true;
        const res = await WizardService.getTrials(
          this.deviceConfiguration.tenantCode
        );
        if (res.length == 1) {
          this.startTrial(res[0]);
        } else {
          this.avaliableTrials = res;
          this.licenseMode = "trial";
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
    async startTrial(prod: LicenseProduct) {
      try {
        this.loading = true;
        const license = await WizardService.startTrial(
          this.deviceConfiguration.deviceConfigurationId,
          this.deviceConfiguration.tenantCode,
          prod.sku,
          this.deviceConfiguration.deviceType
        );
        this.syncLicense(license);
        await this.$nextTick();
        this.onNext();
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loading = false;
      }
    },
  },
});
